export default __webpack_public_path__ + "eeadd2b71a31a94ab36fb4ff16a412d7.svg";